import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const IntentionFragment = gql`
  fragment Intention on crm_intention {
    ${EntityFields}
    ${EnumFields}
  }
`
